import { Injectable } from '@angular/core';
import { Actions, ofType } from '@ngrx/effects';
import * as ActionsList from './actions';
import { map, switchMap } from 'rxjs/operators';
import { createEffect } from '@ngrx/effects';
import { ToastrService } from 'ngx-toastr';
import { EPContributionService } from 'src/app/services/EmployerPortalServices/ep-contribution.service';

@Injectable()
export class EditContributionEffects {
  constructor(private actions$: Actions,
    public toastr: ToastrService,
    private service: EPContributionService) {
  }

  getById$ = createEffect(() => this.actions$.pipe(
    ofType(ActionsList.RequestAction),
    switchMap((action: any) => this.service.getContribution(action.id)),
    map((data: any) => {
      return ActionsList.ResponseAction({ payload: data.data });
    })
  ));

  getCloneById$ = createEffect(() => this.actions$.pipe(
    ofType(ActionsList.RequestCloneAction),
    switchMap((action: any) => this.service.getCloneContribution(action.id)),
    map((data: any) => {
      return ActionsList.ResponseCloneAction({ payload: data.data });
    })
  ));

  save$ = createEffect(() => this.actions$.pipe(
    ofType(ActionsList.SaveRequestAction),
    switchMap((action: any) => this.service.save(action.payload)),
    map((data: any) => {
      this.toastr.success(data.message);
      return ActionsList.SaveResponseAction({ payload: data });
    })
  ));

  submit$ = createEffect(() => this.actions$.pipe(
    ofType(ActionsList.SubmitRequestAction),
    switchMap((action: any) => this.service.submit(action.payload)),
    map((data: any) => {
      this.toastr.success(data.message);
      return ActionsList.SubmitResponseAction({ payload: data });
    })
  ));
}
